jQuery(function($){
	$(document).ready(function(){
		$('input,select,textarea').on('focus change click',function(){
			$('.errors').fadeOut(function(){$('.errors').html('')});
		});
		$('#certificate_next').click(function(e){
			e.preventDefault();
			$('#certificate-form').submit();
		});	

		$('input[name=purchase_type]').change(function(){
			$('.purchase_type').slideUp(500);
			$('.purchase_type_'+$(this).val()).slideDown(500);
			removeAllFromCart();
			$('input[name=otheramount]').val(0);
			$('.moreinfo.active').click();
			$('select#amountSelect').change();
		});

		$('select#amountSelect').change(function(){
			if($(this).val() == ''){
				$('#otheramount').slideDown(500);
			}else{
				$('#otheramount').slideUp(500);
			}
			$('input[name=otheramount]').val($(this).val());
		});

		$('input[name=otheramount]').val($('select#amountSelect').val());

		$('#categories').change(function(){
			showCategoryTreatments();
		});

		$('.moreinfo').click(function(e){
			e.preventDefault();
			$(this).toggleClass('active');
			$(this).parents('.divTreatmentsSelection').find('.showHideInformation').slideToggle(500);
		});

		$('select.times').change(function(){
			var timeprice = $(this).val();
			timeprice = timeprice.split(' - ');
			$(this).siblings('input.timefield').val(timeprice[0]);
			$(this).siblings('input.pricefield').val(timeprice[1]);
		});

		$('.divAddons').each(function(){
			$addOnBox = $(this);
			$addOnBox.find('input').change(function(){
				if($addOnBox.find('input:checked').length >= 3){
					$addOnBox.find('input').not(':checked').prop('disabled',true);
				}else{
					$addOnBox.find('input').prop('disabled',false);
				}
			});
		})

		$('.btnAddtoCart').click(function(e){
			e.preventDefault();
			addUpdateToCart($(this).parents('.divTreatmentsSelection'));
		});

		$('.btnRemovefromCart').click(function(e){
			e.preventDefault();
			if(!confirm('Are you sure?')){
				return false;
			}
			removeFromCart($(this).parents('.divTreatmentsSelection'));
		});

		$('#certificate-form').submit(function(){
			if($('input[name=purchase_type]:checked').length < 1){
				$('.errors').html('Please Select Amount or Treatment.').fadeIn();
				$('body,html').animate({scrollTop:$('.errors').position().top},500);
				return false;
			}else if($('input[name=purchase_type]:checked').val() == "amount" && !Number($('input[name=otheramount]').val()) > 0){
				$('.errors').html('Please enter a valid amount.').fadeIn();
				$('body,html').animate({scrollTop:$('.errors').position().top},500);
				return false;
			}else if($('input[name=purchase_type]:checked').val() == "treatment"){
				if($('.divTreatmentsSelection.added').length == 0){
					$('.errors').html('Please select a treatment.').fadeIn();
					$('body,html').animate({scrollTop:$('.errors').position().top},500);
					return false;
				}
				$('.divTreatmentsSelection').each(function(){
					var treatmentId = $(this).data('id');
					if($(this).find('input.incart').val() == ''){
						$(this).find('input, select').prop('disabled',true);
					}else{
						$(this).find('input, select').prop('disabled',false);
					}
				});
			}
			if($('input[name=purchase_type]:checked').val() == "amount"){
				$('.divTreatmentsSelection').find('input, select').prop('disabled',true);
			}
			return true;
		});

		if(typeof(cartData) != 'undefined')
			recollectTreatmentAmount(cartData);

		if(preselect != '')
			preselectTreatment(preselect);

		$('select[name=gratuity]').change(function(){
			updateGratuity($(this).val());
            updateCartTotal();
		});

		showCategoryTreatments();
	});

	function setCartEvents(){
		$('.editItem').click(function(e){
			e.preventDefault();
			var productId = $(this).parents('.cartItems').data('product-id');
			var $productContainer = $('.divTreatmentsSelection[data-id='+productId+']');
			editItem($productContainer);
		});
	}

	function editItem($productContainer){
		var productId = $productContainer.data('id');
		var categoryId = $productContainer.data('category');
		if(categoryId != $('#categories').val()){
			$('#categories').val(categoryId).change();
		}
		$productContainer.find('.moreinfo:not(.active)').click();
		setTimeout(function(){
			$('html,body').animate({scrollTop:$productContainer.position().top-$('header.siteHeader').height()-20},200);
		},500)
	}

	function addUpdateToCart($productContainer){
		if(!$productContainer.hasClass('added') && $('.divTreatmentsSelection.added').length >= 3){
			$('.errors').html('You cannot add more than 3 treatments. Remove one from the cart and then try again.').fadeIn();
			$('body,html').animate({scrollTop:$('.errors').position().top},500);
			return false;
		}
		var productId = $productContainer.data('id');
		$productContainer.find('input.incart').val(productId);
		$productContainer.find('.moreinfo .moreText').text('Edit').parents('.moreinfo.active').click();
		$productContainer.find('.btnAddtoCart').text('Update Cart');
		$productContainer.find('.btnRemovefromCart').show();
		$productContainer.addClass('added');
		
		var productTitle = $productContainer.find('h3').text();
		var productPrice = parseFloat($productContainer.find('input.pricefield').val());
		var addOnPrice = 0;	
		var addonCartItemText = '';

		$productContainer.find('.divAddons input:checked').each(function(){
			addonCartItemText += '<span class="addonItem" data-addon="'+$(this).val()+'">'+$(this).data('name')+'</span>';
			addOnPrice += parseFloat($(this).data('price'));
		});

		var finalPrice = (productPrice + addOnPrice).toFixed(2);

		var finalText = '<h4 class="cartItemTitle" data-item-total="'+finalPrice+'">';
		finalText += '<span class="cartItemLeft"><i class="fa fa-edit editItem"></i>'+productTitle+'</span><span class="cartItemRight">$'+finalPrice+'</span>';
		finalText += '</h4><div class="cartItemAddons">'+addonCartItemText+'</div></div>';

		if($('.cartItems[data-product-id='+productId+']').length){
			$('.cartItems[data-product-id='+productId+']').html(finalText);	
		}else{
			$('.divCartContent').append('<div class="cartItems" data-product-id="'+productId+'">'+finalText+'</div>');	
		}

		$('select[name=gratuity]').change();
		setCartEvents();
		updateCartTotal();
	}

	function removeFromCart($productContainer){
		var productId = $productContainer.data('id');
		$('.cartItems[data-product-id='+productId+']').remove();

		$productContainer.find('input.incart').val('');
		$productContainer.find('.moreinfo .moreText').text('More info').parents('.moreinfo.active').click();
		$productContainer.find('.btnRemovefromCart').hide();
		$productContainer.find('.btnAddtoCart').text('Add to Cart');
		$productContainer.find('.divAddons input').each(function(){
			$(this).prop('checked',false);
			$(this).prop('disabled',false);
		});
		$productContainer.removeClass('added');

		setCartEvents();
		updateCartTotal();
	}

	function removeAllFromCart(){
		$('.divTreatmentsSelection.added').each(function(){
			removeFromCart($(this));
		});
		$('.cartItems[data-product-id=0]').remove();
		$('.cartItems[data-product-id=99999]').remove();

		setCartEvents();
		updateCartTotal();
	}

	function showCategoryTreatments(){
		$('.moreinfo.active').click();
		$('.divTreatmentsSelection').slideUp(500);
		$('.divTreatmentsSelection[data-category='+$('#categories').val()+']').slideDown(500);
	}

	function recollectTreatmentAmount(data){
		if(data.purchase_type == 'amount'){
			$('#purchase_type_amount').prop('checked',true).change();
			var optionSelected = false;
			$('#amountSelect option').each(function(){
				if($(this).attr('value') == data.total){
					$(this).prop('selected',true);
					optionSelected = true;
					return;
				}
			});
			if(!optionSelected){
				$('#amountSelect').val('').change();
			}
			$('input[name=otheramount]').val(data.total);
			fillCart(data);
		}else if(data.purchase_type == 'treatment'){
			if(!$.isArray(data.treatments)){
				data.treatments = data.treatments;
			}
			if(!$.isArray(data.treatments)){
				return false;
			}
			$('#purchase_type_treatment').prop('checked',true).change();
			setTimeout(function(){
				$('select[name=gratuity]').val(data.gratuity).change();
			},500);

			data.treatments.forEach(function(treatment){
				var $productContainer = $('.divTreatmentsSelection[data-id='+treatment.id+']');
				$productContainer.find('.times').val(treatment.time+' - '+treatment.price).change();
				treatment.addons.forEach(function(addon){
					$productContainer.find('.divAddons input[value="'+addon.title+'|'+addon.price+'"]').prop('checked',true).change();
				});
				addUpdateToCart($productContainer);
			});
		}
	}

	function preselectTreatment(preselect){
		$('#purchase_type_treatment').prop('checked',true).change();

		var $productContainer = $('.divTreatmentsSelection[data-id='+preselect+']');
		addUpdateToCart($productContainer);
		setTimeout(function(){
			editItem($productContainer);
			setTimeout(function(){
				$productContainer.find('.moreinfo:not(.active)').click();
			},100);
		},100);
	}
});


// WEBPACK FOOTER //
// ./resources/assets/js/certificate.js